export default __webpack_public_path__ + "static/RemoveBranding-6119cfd337f817d3ca74a085c2aecbeb.png";